import { createSlice } from "@reduxjs/toolkit"
import {
  clearMenuCache,
  getForceUpdateData,
  getGlobalSettingByType,
  getPrivacyPolicy,
  getTermsConditions,
  updateGlobalSettingByType,
} from "store/actions/globalSettingAction"

const initialState = {
  loading: true,
  isLoading: false,
  vatInfo: {},
  referralInfo: {},
  loyaltyInfo: {},
  globalSettings: {},
  maintenanceMode: {},
  forceAppUpdate: {},
  privacyPolicy: {},
  termsConditions: {},
  giftCardInfo: {},
}

const usersSlice = createSlice({
  name: "Global Settings",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // FETCH ALL GLOBAL SETTING
    builder
      .addCase(getGlobalSettingByType.pending, state => {
        state.loading = true
      })
      .addCase(getGlobalSettingByType.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { type } = action.meta.arg
          if (type === "vatInfo") {
            state.vatInfo = data
          } else if (type === "referralInfo") {
            state.referralInfo = data
          } else if (type === "loyaltyInfo") {
            state.loyaltyInfo = data
          } else if (type === "globalSettings") {
            state.globalSettings = data
          } else if (type === "maintenanceMode") {
            state.maintenanceMode = data
          } else if (type === "giftCardInfo") {
            state.giftCardInfo = data
          }
        }
      })
      .addCase(getGlobalSettingByType.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(getForceUpdateData.pending, state => {
        // state.loading = true
      })
      .addCase(getForceUpdateData.fulfilled, (state, action) => {
        // state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.forceAppUpdate = data
        }
      })
      .addCase(getForceUpdateData.rejected, (state, action) => {
        // state.loading = false
      })

    // UPDATE GLOBAL SETTING
    builder
      .addCase(updateGlobalSettingByType.pending, state => {
        state.isLoading = true
      })
      .addCase(updateGlobalSettingByType.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateGlobalSettingByType.rejected, (state, action) => {
        state.isLoading = false
      })

    // CLEAR MENU CACHE
    builder
      .addCase(clearMenuCache.pending, state => {
        state.isLoading = true
      })
      .addCase(clearMenuCache.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(clearMenuCache.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(getPrivacyPolicy.pending, state => {
        state.loading = true
      })
      .addCase(getPrivacyPolicy.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.privacyPolicy = data
        }
      })
      .addCase(getPrivacyPolicy.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(getTermsConditions.pending, state => {
        state.loading = true
      })
      .addCase(getTermsConditions.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.termsConditions = data
        }
      })
      .addCase(getTermsConditions.rejected, (state, action) => {
        state.loading = false
      })
  },
})

export default usersSlice.reducer
